<template>
	<TwoPartsTreeBlock @click.native="onClickBlock(blockData)" v-on="$listeners" :isChosen="isChosen">
		<template #first-part>
			<FlowTreeActionBlock
				disabled
				:blockData="{ service: 'some-value', node_title: nodeTitle }"
				:appData="{ service_slug: addOnIcon }"
				:actionData="{}"
				hideStatus
			/>
		</template>
		<template #second-part>
			<ElementTreeBlockButton
				class="flex-centerize"
				:element="element"
				:isNative="isNativeElement"
				:placement="placement"
				:workflow="editWorkflow"
			/>
		</template>
	</TwoPartsTreeBlock>
</template>

<script>
import FlowTreeMixin from '@/components/FlowTree/FlowTreeMixin';
import ElementTreeBlockButton from './ElementTreeBlockButton';
import FlowTreeActionBlock from '../FlowTreeActionBlock.vue';
import TwoPartsTreeBlock from '../TwoPartsTreeBlock.vue';
import { mapGettersShorthand, mapActionsShorthand } from '@/store/utils/mappers';
import { editNode } from '@/store/modules/selectedNode/getters';
import { element, isNativeElement, editWorkflow } from '@/store/modules/selectedWorkflow/getters';
import { getActionsOfApp } from '@/store/modules/apps/actions';
import { getService } from '@/store/modules/apps/getters';
import PlacementService from '@/utils/placement-service';
import { getPlacement } from '@/store/modules/placements/getters';

export default {
	name: 'ElementTreeBlock',
	mixins: [FlowTreeMixin],
	components: {
		ElementTreeBlockButton,
		FlowTreeActionBlock,
		TwoPartsTreeBlock,
	},
	props: {
		blockData: {
			type: Object,
		},
	},
	computed: {
		...mapGettersShorthand({ editNode, element, isNativeElement, getService, getPlacement, editWorkflow }),
		placement() {
			return this.getPlacement(this.element.placement);
		},
		addOnIcon() {
			return PlacementService.getAddOnIcon(this.placement);
		},
		nodeTitle() {
			return `Display ${PlacementService.getAddOnType(this.placement, this.element.type)}`;
		},
		service() {
			return this.getService(this.placement.service);
		},
		isChosen() {
			return this.blockData.id === this.editNode?.id;
		},
	},
	methods: {
		...mapActionsShorthand({ getActionsOfApp }),
	},
	mounted() {
		if (this.service) {
			this.getActionsOfApp({ id: this.service.id, version: this.service.version });
		}
	},
};
</script>

<style scoped lang="scss">
::v-deep {
	.ui-element {
		width: 100%;
	}
}
</style>
